<template>
  <ProductCard
    :color-swatches="
      colorSwatches(
        product.specifications,
        productGranularity ?? product.granularity,
      )
    "
    data-test="product-card"
    :deal="product.deal"
    :description="product.description"
    :discounted-price="product.discountedPrice"
    :extended-description="
      extendedDescription(productGranularity ?? product.granularity)
    "
    :grade="product.grade"
    :granularity="productGranularity ?? product.granularity"
    :image-alt="product.title"
    :image-src="product.image"
    :listing-id="product.listingId"
    :listing-public-id="product.listingPublicId ?? ''"
    :marketing-tags="product.marketingTags"
    :position="index + 1"
    :price="product.price"
    :price-new="product.priceNew"
    :product
    :review-rating="product.reviewRating"
    :special-offer-type="product.specialOfferType"
    :title="product.title"
    :tracking
    :url="product.productPageLink"
    :with-starting-from="
      withStartingFrom(productGranularity ?? product.granularity)
    "
    v-on="addToCartListener ? { addToCart: handleAddToCart(product) } : {}"
    @link-click="
      trackProductClick(product, {
        granularity: productGranularity ?? product.granularity,
        ...tracking,
        position: index + 1,
        source: tracking?.source ?? 'recommendation',
      })
    "
  />
</template>

<script setup lang="ts">
import { getCurrentInstance } from 'vue'

import type { ProductGranularity } from '@backmarket/http-api/src/api-specs-content/shared/product-granularity'

import {
  type ExtraTrackingData,
  useClickTracking,
} from '../../composables/useProductTracking'
import type { Product } from '../../models/product'
import ProductCard from '../ProductCard/ProductCard.vue'

import {
  colorSwatches,
  extendedDescription,
  withStartingFrom,
} from './ProductCardVersion.helper'

withDefaults(
  defineProps<{
    product: Product
    tracking?: ExtraTrackingData

    productGranularity?: ProductGranularity
    index: number
  }>(),
  {
    tracking: () => ({}),

    productGranularity: undefined,
  },
)

const emits = defineEmits<{
  (e: 'add-to-cart', data: { status: string; product: Product }): void
}>()

const addToCartListener = getCurrentInstance()?.vnode.props?.onAddToCart

const { trackProductClick } = useClickTracking()

function handleAddToCart(product: Product) {
  return ({ status }: { status: string }) => {
    emits('add-to-cart', { status, product })
  }
}
</script>
